import routerOptions0 from "/home/runner/work/mfx-framework/mfx-framework/node_modules/.pnpm/nuxt@3.7.3_@types+node@16.18.52_eslint@8.49.0_typescript@5.2.2_vue-tsc@1.8.11/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions0,
}